var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Box, Button, Container, FormControlLabel, Grid, makeStyles, Paper, Switch, Table, TableBody, TableCell, TableHead, TableRow, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import _, { range } from 'lodash';
import moment from 'moment';
import { getAccommodationDisplayName } from 'hotelAccommodationDisplay';
import { useSnackbar } from 'notistack';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { DateRangePickerField } from 'react-components/DateRangePickerField';
import { useHistory, useLocation } from 'react-router-dom';
import { formatString, _T } from '../../../include/appI18n';
import $ from '../../../include/jquery.js';
import { api } from '../../../include/network/network';
import { BackdropContext } from '../../../include/react-components/BackdropProvider';
import { GlobalSpinnerContext } from '../../../include/react-components/GlobalSpinnerProvider';
import { HorizontalScrollableBox } from '../../../include/react-components/HorizontalScrollableBox';
import Select from '../../../include/react-components/Select';
import '../../../include/sticky.table.js';
import { appUrl, formatMoney, toURLSearchParams } from '../../../include/utils';
import { AccommodationSelector } from '../../Frame/components/AccommodationSelector';
import GroupedMultiSelectList from '../../NewTourSearch/compoments/GroupedMultiSelectList';
import MultiSelectList from '../../NewTourSearch/compoments/MultiSelectList';
import '../../NewTourSearch/compoments/TourSearch.css';
import { GagraHotelSearchResultCard } from './GagraHotelSearchResultCard';
import { isCapitalUI } from '../../../include/react-common/theme';
import { CapitalHotelSearchForm } from './CapitalHotelSearchForm';
import { HotelCompulsoryServicesDialog } from './HotelCompulsoryServicesDialog';
import '../../NewTourSearch/compoments/capital-tour-search.css';
import './capital-hotel-search.css';
import { HotelOfferConditions } from '../../TourSearch/components/HotelOfferConditions';
const getCompulsoryOptionPrice = (option) => Number.parseFloat(`${option.price.price}`.replace(',', '.')) || 0;
const useStyles = makeStyles(theme => ({
    gridFilterFirstSecond: {
        width: `calc(100% + ${theme.spacing(2)}px)`,
        margin: -theme.spacing(1),
        '& > .MuiGrid-item': {
            padding: theme.spacing(1),
        },
        [theme.breakpoints.between("xs", "sm")]: {
            width: `calc(100% + ${theme.spacing(1)}px)`,
            marginLeft: -theme.spacing(0.5),
            marginRight: -theme.spacing(0.5),
            '& > .MuiGrid-item': {
                paddingLeft: theme.spacing(0.5),
                paddingRight: theme.spacing(0.5),
            },
        },
    },
}));
const parseHiddenColumns = (value) => {
    if (!value)
        return new Set();
    const list = Array.isArray(value) ? value : value.split(',');
    return new Set(list.map(v => v.trim().toLowerCase()).filter(v => v));
};
export default function HotelSearch(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const capital = props.hotelSearchResultVariant === 'capital';
    const [searchFailed, setSearchFailed] = useState(false);
    const SearchSurface = capital ? 'div' : React.Fragment;
    const snackbar = useSnackbar();
    const backdrop = useContext(BackdropContext);
    const spinner = useContext(GlobalSpinnerContext);
    const classes = useStyles();
    const theme = useTheme();
    const xs = useMediaQuery(theme.breakpoints.down("sm"));
    const md = useMediaQuery(theme.breakpoints.down("lg"));
    const resultsContainerRef = useRef(null);
    const resultsScrollRef = useRef(null);
    const fetchErrorMessage = _T.NEW_TOUR_SEARCH_FETCH_ERROR;
    const onFetchErrorMessageClick = () => location.reload();
    const history = useHistory();
    const { pathname, search: searchStr, state: historyState } = useLocation();
    const searchParams = useMemo(() => new URLSearchParams(searchStr), [searchStr]);
    const [variant, setVariant] = useState('filled');
    const hotelSearchConfig = props.hotelSearch;
    const hotelSearchFields = hotelSearchConfig === null || hotelSearchConfig === void 0 ? void 0 : hotelSearchConfig.filterFields;
    const hiddenColumns = useMemo(() => parseHiddenColumns(hotelSearchConfig === null || hotelSearchConfig === void 0 ? void 0 : hotelSearchConfig.hiddenColumns), [hotelSearchConfig === null || hotelSearchConfig === void 0 ? void 0 : hotelSearchConfig.hiddenColumns]);
    const showNoStopSalesSwitch = !((_b = (_a = hotelSearchFields === null || hotelSearchFields === void 0 ? void 0 : hotelSearchFields.noStopSalesSwitch) === null || _a === void 0 ? void 0 : _a.hidden) !== null && _b !== void 0 ? _b : false);
    const showChildsWithPlaceOnlySwitch = !((_d = (_c = hotelSearchFields === null || hotelSearchFields === void 0 ? void 0 : hotelSearchFields.childsWithPlaceOnlySwitch) === null || _c === void 0 ? void 0 : _c.hidden) !== null && _d !== void 0 ? _d : false);
    const columnVisibility = {
        price: !hiddenColumns.has('price'),
        dates: !hiddenColumns.has('dates'),
        hotel: !hiddenColumns.has('hotel'),
        hotelCategory: !hiddenColumns.has('hotelcategory'),
        roomCategory: !hiddenColumns.has('roomcategory'),
        roomType: !hiddenColumns.has('roomtype'),
        accommodation: !hiddenColumns.has('accommodation'),
        meal: !hiddenColumns.has('meal'),
        nights: !hiddenColumns.has('nights'),
    };
    const [initialized, setInitialized] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [validationCounter, setValidationCounter] = useState(0);
    const paramIntOrDefault = (paramName, defaultValue) => {
        let param = searchParams.get(paramName);
        if (!param)
            return defaultValue;
        let paramInt = Number.parseInt(param);
        if (!Number.isInteger(paramInt))
            return defaultValue;
        return paramInt;
    };
    const paramIntArray = (paramName) => {
        //let params = searchParams.getAll(paramName) || searchParams.getAll(`${paramName}[]`);
        let params = _.filter([...searchParams], x => _.startsWith(x[0], paramName)).map(x => x[1]);
        if (!params)
            return [];
        return params.map(param => Number.parseInt(param)).filter(param => Number.isInteger(param));
    };
    const getBoolParamOrDefault = (paramName, defaultValue) => {
        const param = searchParams.get(paramName);
        if (param === null || param === '')
            return defaultValue;
        return param == 'true' || param == '1';
    };
    const restoreDates = () => {
        let from = moment(searchParams.get('from') || searchParams.get('dateFrom'));
        let to = moment(searchParams.get('to') || searchParams.get('dateTo'));
        return from.isValid() && to.isValid() ? [from.format('YYYY-MM-DD'), to.format('YYYY-MM-DD')] : [undefined, undefined];
    };
    const restoreAges = (prop) => {
        let ages = _.filter([...searchParams], x => _.startsWith(x[0], prop)).map(x => Number.parseInt(x[1]));
        //let ages = paramIntArray(prop);
        return range(0, 4).map(x => ages.length > x ? ages[x] : 2);
    };
    const includeStopSaleParam = (_e = searchParams.get('includeStopSale')) !== null && _e !== void 0 ? _e : searchParams.get('includeStopSaleHotels');
    const [{ countryTo, regionTo, cityTo, starTo, hotel, dates, pansion, livingCondition, rooms, noStopSales, childsWithPlaceOnly }, setFilters_] = useState({
        noStopSales: includeStopSaleParam == null ? (typeof hotelSearchFields.noStopSalesSwitch.defaultValue == "boolean" ? hotelSearchFields.noStopSalesSwitch.defaultValue : true) : includeStopSaleParam == 'false' || includeStopSaleParam == '0',
        countryTo: paramIntOrDefault('countryTo'),
        regionTo: paramIntArray('regionTo'),
        cityTo: paramIntArray('cityTo'),
        starTo: paramIntArray('starTo'),
        hotel: paramIntArray('hotelTo'),
        dates: restoreDates(),
        pansion: paramIntArray('pansionTo'),
        livingCondition: paramIntArray('livingConditionTo'),
        childsWithPlaceOnly: getBoolParamOrDefault('childsWithPlaceOnly', (_g = (_f = hotelSearchFields === null || hotelSearchFields === void 0 ? void 0 : hotelSearchFields.childsWithPlaceOnlySwitch) === null || _f === void 0 ? void 0 : _f.defaultValue) !== null && _g !== void 0 ? _g : false),
        rooms: (_.filter([...searchParams], x => _.startsWith(x[0], 'rooms')).length > 0 ? Object.entries(_.groupBy(_.filter([...searchParams], x => _.startsWith(x[0], 'rooms')), q => q[0].slice(0, q[0].indexOf(']') + 1))).map(x => {
            return [Object.fromEntries(x[1])].map(e => ({ adults: Number.parseInt(e[`${x[0]}.adults`]), childs: Number.parseInt(e[`${x[0]}.childs`]), childAccommodations: restoreAges(`${x[0]}.ages`).slice(0, Number.parseInt(e[`${x[0]}.childs`])).map(a => ({ age: a, withPlace: true })) }))[0];
        }) : undefined) || [{ adults: 2, childs: 0, childAccommodations: [] }],
    });
    const setFilters = (p) => {
        setFilters_(prev => (Object.assign(Object.assign({}, prev), p)));
    };
    const setNoStopSales = (value) => setFilters({ noStopSales: value });
    const setChildsWithPlaceOnly = (value) => setFilters({ childsWithPlaceOnly: value });
    const setCountryTo = (value) => setFilters({ countryTo: value });
    const [countryToOpt, setCountryToOpt] = useState([]);
    const countryToReal = useMemo(() => countryToOpt.find(x => x.id == countryTo) ? countryTo : undefined, [countryToOpt, countryTo]);
    const countryToError = useMemo(() => !countryToReal, [countryToReal && validationCounter > 0, validationCounter]);
    const setRegionTo = (value) => setFilters({ regionTo: value });
    const [regionToOpt, setRegionToOpt] = useState([]);
    const regionToReal = useMemo(() => regionTo.filter(c => !!regionToOpt.find(x => x.id == c)), [regionToOpt, regionTo]);
    const setCityTo = (value) => setFilters({ cityTo: value });
    const [cityToOpt, setCityToOpt] = useState([]);
    const cityToReal = useMemo(() => cityTo.filter(c => !!cityToOpt.find(x => x.id == c)), [cityToOpt, cityTo]);
    const cityToError = useMemo(() => !!props.newHotelSearchMaxCityCount && (cityToReal.length > props.newHotelSearchMaxCityCount || (cityToOpt.length > props.newHotelSearchMaxCityCount && cityToReal.length == 0)) && validationCounter > 0, [props.newHotelSearchMaxCityCount, cityToReal, cityToOpt, validationCounter]);
    const setStarTo = (value) => setFilters({ starTo: value });
    const [starToOpt, setStarToOpt] = useState([]);
    const setHotel = (value) => setFilters({ hotel: value });
    const [hotelOpt, setHotelOpt] = useState([]);
    const hotelOptFiltered = useMemo(() => {
        return !(starTo === null || starTo === void 0 ? void 0 : starTo.length) ? hotelOpt : hotelOpt.filter(h => h.category && h.category.id && starTo.includes(h.category.id));
    }, [hotelOpt, starTo]);
    const prevCityToRef = useRef(cityTo);
    useEffect(() => {
        if (!initialized) {
            prevCityToRef.current = cityTo;
            return;
        }
        if (!_.isEqual(prevCityToRef.current, cityTo)) {
            setHotel([]);
        }
        prevCityToRef.current = cityTo;
    }, [cityTo, initialized]);
    const setDates = (value) => setFilters({ dates: value });
    //const [datesOpt, setDatesOpt] = useState<string[]>([]);
    const datesError = useMemo(() => (!dates[0] || !moment(dates[0]).isValid() || !dates[1] || !moment(dates[1]).isValid() || moment(dates[1]).diff(moment(dates[0]), "days") < 1) && validationCounter > 0, [...dates, validationCounter]);
    const setPansion = (value) => setFilters({ pansion: value });
    const [pansionOpt, setPansionOpt] = useState([]);
    const setLivingCondition = (value) => setFilters({ livingCondition: value });
    const [livingConditionOpt, setLivingConditionOpt] = useState([]);
    const livingConditionAndPansionSelected = useMemo(() => [
        ...pansion.map(x => ({ group: 'meal', value: x })),
        ...livingCondition.map(x => ({ group: 'other', value: x })),
    ], [pansion, livingCondition]);
    const livingConditionAndPansionOpt = useMemo(() => [
        {
            group: 'meal',
            options: pansionOpt,
        },
        {
            group: 'other',
            options: livingConditionOpt,
        }
    ], [pansionOpt, livingConditionOpt]);
    const setRooms = (value) => setFilters({ rooms: value });
    const [searchResult, setSearchResult] = useState();
    const [resultGroups, setResultGroups] = useState([]);
    const [pageIndex, setPageIndex] = useState(0);
    const [searching, setSearching] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const loadingMoreRef = useRef(false);
    const searchVersion = useRef(0);
    const [lastSearchParams, setLastSearchParams] = useState();
    const capitalFilterKey = JSON.stringify([countryTo, regionTo, cityTo, starTo, hotel, dates, pansion, livingCondition, rooms, noStopSales, childsWithPlaceOnly]);
    const previousCapitalFilterKey = useRef(capitalFilterKey);
    useEffect(() => {
        if (!capital || previousCapitalFilterKey.current === capitalFilterKey)
            return;
        previousCapitalFilterKey.current = capitalFilterKey;
        searchVersion.current++;
        setSearchResult(undefined);
        setResultGroups([]);
        setSearchFailed(false);
        setSearching(false);
        setLastSearchParams(undefined);
        setPageIndex(0);
    }, [capital, capitalFilterKey]);
    const resultRows = useMemo(() => {
        return _.orderBy(resultGroups.flatMap(group => (group.hotelPrices || []).map(price => ({ group, price }))), x => x.price.price);
    }, [resultGroups]);
    const gagraResultGroups = useMemo(() => _.orderBy(resultGroups
        .map(group => ({
        group,
        price: _.minBy(group.hotelPrices || [], price => price.price),
    }))
        .filter((item) => !!item.price), item => item.price.price), [resultGroups]);
    const [addingToCart, setAddingToCart] = useState(false);
    const [compulsoryDialogOpen, setCompulsoryDialogOpen] = useState(false);
    const [compulsoryOptions, setCompulsoryOptions] = useState([]);
    const [compulsorySelection, setCompulsorySelection] = useState(null);
    const [pendingRoomEntry, setPendingRoomEntry] = useState(null);
    function apiBackdrop(promise, useSpinner, timeout) {
        return __awaiter(this, void 0, void 0, function* () {
            if (useSpinner)
                spinner.show();
            else
                backdrop.show();
            let result = yield promise();
            setTimeout(() => {
                if (useSpinner)
                    spinner.hide();
                else
                    backdrop.hide();
            }, timeout !== null && timeout !== void 0 ? timeout : 200);
            return result;
        });
    }
    const resolveRoomIndex = (price) => {
        var _a;
        if (price.roomNo)
            return Math.max(price.roomNo - 1, 0);
        if ((_a = price.allRoomNos) === null || _a === void 0 ? void 0 : _a.length)
            return Math.max(price.allRoomNos[0] - 1, 0);
        if (price.allRoomNo) {
            const token = price.allRoomNo.split(';')[0];
            const parsed = Number.parseInt(token);
            if (Number.isFinite(parsed) && parsed > 0)
                return parsed - 1;
        }
        return 0;
    };
    const getRoomsValue = (price) => {
        var _a;
        if (price.allRoomNo)
            return price.allRoomNo;
        if ((_a = price.allRoomNos) === null || _a === void 0 ? void 0 : _a.length)
            return price.allRoomNos.join(';');
        if (price.roomNo)
            return `${price.roomNo}`;
        return '1';
    };
    const buildRoomEntry = (price) => ({
        roomCount: 1,
        serialized: price.secureSerialized,
        rooms: getRoomsValue(price),
        availability: price.immediateConfirm ? 1 : 0,
        'provider-id': price.externalProviderId,
        'variant-id': price.bookingCode,
        compulsoryServiceParams: null,
    });
    const buildCompulsoryRooms = (price) => {
        var _a;
        const roomIndex = resolveRoomIndex(price);
        const accmd = (_a = rooms[roomIndex]) !== null && _a !== void 0 ? _a : rooms[0];
        if (!accmd)
            return [];
        const children = (accmd.childAccommodations || []).slice(0, accmd.childs || 0).map(a => a.age);
        return [{
                callerGeneratedId: 0,
                adults: accmd.adults,
                children,
                quantity: 1,
            }];
    };
    const fetchCompulsoryServicePrices = (hotelId, providerId, descriptor, roomRequests) => __awaiter(this, void 0, void 0, function* () {
        var _h, _j;
        if (!((_h = descriptor === null || descriptor === void 0 ? void 0 : descriptor.services) === null || _h === void 0 ? void 0 : _h.length) || !roomRequests.length)
            return null;
        const rq = {
            hotelId,
            providerId,
            currencyId: descriptor.currencyId,
            checkIn: descriptor.checkIn,
            checkOut: descriptor.checkOut,
            services: descriptor.services.map(s => ({ id: s.id, classId: s.classId })),
            rooms: roomRequests.map(r => ({
                callerGeneratedId: r.callerGeneratedId,
                adultBuyers: r.adults,
                childBuyers: r.children,
                quantity: r.quantity,
            })),
        };
        const r = yield api('get', '/Hotel/GetCompulsoryServicePrices', rq);
        if (!((_j = r.response) === null || _j === void 0 ? void 0 : _j.servicePrices) || !Array.isArray(r.response.servicePrices))
            return null;
        return r.response.servicePrices.map(price => {
            const svc = descriptor.services.find(s => s.id == price.id && s.classId == price.classId);
            if (!svc)
                return null;
            return { name: svc.name, price };
        }).filter((option) => !!option)
            .sort((a, b) => {
            const priceCompare = getCompulsoryOptionPrice(a) - getCompulsoryOptionPrice(b);
            return priceCompare || `${a.price.validOnIso}`.localeCompare(`${b.price.validOnIso}`);
        });
    });
    const addToCart = (roomEntry, replaceCart = false) => __awaiter(this, void 0, void 0, function* () {
        var _k, _l;
        if (!(searchResult === null || searchResult === void 0 ? void 0 : searchResult.rqSerialized) || addingToCart)
            return;
        setAddingToCart(true);
        const cartData = { searchParamsSerialized: searchResult.rqSerialized };
        cartData['rooms[0]'] = JSON.stringify(roomEntry);
        cartData.replaceCart = replaceCart;
        const r = yield apiBackdrop(() => api('post', '/Hotel/AddToCart', cartData), false, 900);
        setAddingToCart(false);
        if ((_k = r.response) === null || _k === void 0 ? void 0 : _k.success) {
            window.open(appUrl('/Cart'), '_blank', 'noopener,noreferrer');
        }
        else {
            if (((_l = r.response) === null || _l === void 0 ? void 0 : _l.errorCode) && r.response.errorCode.startsWith('CART_CONFLICT')) {
                const reason = r.response.errorCode === 'CART_CONFLICT_CURRENCY' ? 'currency' : 'service';
                const showModal = window.showCartConflictModal;
                if (showModal) {
                    showModal({
                        reason,
                        onReplace: () => addToCart(roomEntry, true),
                    });
                    return;
                }
            }
            snackbar.enqueueSnackbar(_T.ROOM_UNAVAILABLE_RATE || fetchErrorMessage, { variant: 'error', autoHideDuration: 10000, onClick: onFetchErrorMessageClick });
        }
    });
    const handlePriceClick = (evt, group, price) => __awaiter(this, void 0, void 0, function* () {
        var _m, _o, _p;
        evt.preventDefault();
        if (!searchResult || addingToCart)
            return;
        const roomEntry = buildRoomEntry(price);
        const servicesDescriptor = (_o = (_m = searchResult.compulsoryServices) === null || _m === void 0 ? void 0 : _m.services) === null || _o === void 0 ? void 0 : _o[group.hotelId.toString()];
        if ((_p = servicesDescriptor === null || servicesDescriptor === void 0 ? void 0 : servicesDescriptor.services) === null || _p === void 0 ? void 0 : _p.length) {
            const roomRequests = buildCompulsoryRooms(price);
            const servicePrices = yield fetchCompulsoryServicePrices(group.hotelId, price.partnerId, servicesDescriptor, roomRequests);
            if (servicePrices === null || servicePrices === void 0 ? void 0 : servicePrices.length) {
                if (servicePrices.length == 1) {
                    roomEntry.compulsoryServiceParams = {
                        id: servicePrices[0].price.id,
                        classId: servicePrices[0].price.classId,
                        serviceActivationDate: servicePrices[0].price.validOnIso,
                        serviceDuration: servicePrices[0].price.duration,
                    };
                    yield addToCart(roomEntry);
                    return;
                }
                setPendingRoomEntry(roomEntry);
                setCompulsoryOptions(servicePrices);
                setCompulsorySelection(0);
                setCompulsoryDialogOpen(true);
                return;
            }
        }
        yield addToCart(roomEntry);
    });
    const closeCompulsoryDialog = () => {
        setCompulsoryDialogOpen(false);
        setCompulsoryOptions([]);
        setCompulsorySelection(null);
        setPendingRoomEntry(null);
    };
    const handleCompulsoryConfirm = () => __awaiter(this, void 0, void 0, function* () {
        if (pendingRoomEntry == null || compulsorySelection == null)
            return;
        const chosen = compulsoryOptions[compulsorySelection];
        if (!chosen)
            return;
        const roomEntry = Object.assign(Object.assign({}, pendingRoomEntry), { compulsoryServiceParams: {
                id: chosen.price.id,
                classId: chosen.price.classId,
                serviceActivationDate: chosen.price.validOnIso,
                serviceDuration: chosen.price.duration,
            } });
        closeCompulsoryDialog();
        yield addToCart(roomEntry);
    });
    const CartIcon = () => isCapitalUI ? React.createElement("img", { src: appUrl('/Content/capital/assets/search-cart.svg'), alt: "" }) : (React.createElement("span", null,
        React.createElement("svg", { viewBox: "0 0 30 30", width: "32", height: "32", "aria-hidden": "true", className: "tp-price-cart-icon" },
            React.createElement("g", null,
                React.createElement("path", { d: "M27.088925,3.7484c-0.0675,0.016-0.13328,0.021-0.19492,0.053l-2.92685,1.6766-0.45376,1.9566-20.48329,0.037c-0.37463,0.066-0.75322,0.1233-0.76563,0.7335l2.5074,9.7482c0.0886,0.5069,0.15454,0.5593,0.69701,0.6632l15.22369,2.0973 0,0.8383-13.72517,0c-0.3354,0-0.44445,0.1649-0.53329,0.3363-0.81071,0.3289-1.38312,1.1255-1.38312,2.0565 0,1.2255 0.99096,2.2194 2.21268,2.2194 1.22172,0 2.21112-0.9939 2.21112-2.2194 0-0.3608-0.0863-0.7013-0.23858-1.0024l8.32056-0.019c-0.18782,0.3259-0.29627,0.7053-0.29627,1.1089 0,1.2253 0.99096,2.2192 2.21268,2.2192 1.22172,0 2.21112-0.9939 2.21112-2.2192 0-0.4078-0.10986-0.7902-0.30095-1.1184l0.2838,0c0.19545-0.1201 0.40413-0.2173 0.41946-0.699l0.0343-2.2365 3.1358-13.6614 2.15966-1.2918c0.6725-0.6428 0.14513-1.2974-0.32746-1.2762zm-23.22302,5.1189h2.15966v2.7088h-1.44237zM7.036,8.8673H10.4681v2.7088H7.036zM11.4785,8.8673h3.43052v2.7088h-3.43052zM15.9195,8.8673h3.43207v2.7088h-3.43207zM20.362,8.8673h2.80367l-0.644,2.7088h-2.15967zM4.8514,12.5881h1.17417v2.97h-0.38827zM7.036,12.5881h3.43207v2.97H7.036zM11.4785,12.5881h3.43052v2.97h-3.43052zM15.9195,12.5881h3.43207v2.97h-3.43207zM20.362,12.5881h1.91953l-0.70481,2.97h-1.21472zM5.90552,16.5716h0.12006v0.4519h-0.12006zM7.036,16.5716h3.43207v1.3137L7.036,17.416zM11.4785,16.5716h3.43052v1.9189l-3.43052-0.4677zM15.9195,16.5716h3.43207v2.5257l-3.43207-0.4691zM20.362,16.5716h0.97458l-0.644,2.7088-0.33058-0.045zM8.234,22.9448c0.40424,0.1505,0.69234,0.5413,0.69234,0.9993 0,0.5886-0.47509,1.0666-1.0619,1.0666-0.58681,0-1.06346-0.478-1.06346-1.0666 0-0.4563 0.28699-0.8461 0.68922-0.9979h0.7438zm11.78537,0.022c0.0181,0 0.0362,0 0.0546,0 0.58681,0 1.0619,0.4764 1.0619,1.065 0,0.5885-0.47509,1.0666-1.0619,1.0666-0.58681,0-1.06346-0.4781-1.06346-1.0666 0-0.5701 0.44743-1.0365 1.00889-1.065z" })))));
    const loadFilters = () => __awaiter(this, void 0, void 0, function* () {
        setUpdating(true);
        yield apiBackdrop(() => __awaiter(this, void 0, void 0, function* () {
            const params = {
                regionTo: regionToReal.filter(c => !initialized || !!regionToOpt.find(x => x.id == c)),
                countryTo: !initialized || countryToOpt.find(x => x.id == countryTo) ? countryTo : undefined,
                cityTo: cityToReal.filter(c => !initialized || !!cityToOpt.find(x => x.id == c)),
                starTo,
                hotelTo: hotel.filter(c => !initialized || !!hotelOpt.find(x => x.id == c)),
                //dateFrom: dates[0] || null,
                //dateTo: dates[1] || null,
            };
            const r = yield api('post', '/NewHotel/Filters', params);
            if (r.response) {
                setCountryToOpt(r.response.countryTo);
                setRegionToOpt(r.response.regionTo);
                setCityToOpt(r.response.cityTo);
                setStarToOpt(r.response.starTo);
                setHotelOpt(r.response.hotelTo);
                //let datesOptTemp = r.response.dateTo.map(x => moment(x).format('YYYY-MM-DD'));
                //setDatesOpt(datesOptTemp);
                setPansionOpt(r.response.pansionTo);
                setLivingConditionOpt(r.response.livingConditionTo);
                if (r.response.currentCountryTo)
                    setCountryTo(r.response.currentCountryTo);
                setRegionTo(regionTo.filter(v => r.response.regionTo.find(x => x.id == v)));
                setCityTo(cityTo.filter(v => r.response.cityTo.find(x => x.id == v)));
                setStarTo(starTo.filter(v => r.response.starTo.find(x => x.id == v)));
                setHotel(hotel.filter(v => r.response.hotelTo.find(x => x.id == v)));
                setPansion(pansion.filter(v => r.response.pansionTo.find(x => x.id == v)));
                setLivingCondition(livingCondition.filter(v => r.response.livingConditionTo.find(x => x.id == v)));
                //if (!datesOptTemp.find(x => x == dates[0]) || !datesOptTemp.find(x => x == dates[1]))
                //    setDates([undefined, undefined]);
            }
            else {
                snackbar.enqueueSnackbar(fetchErrorMessage, { variant: 'error', autoHideDuration: 10000, onClick: onFetchErrorMessageClick });
            }
            return r;
        })).finally(() => setTimeout(() => setUpdating(false), 200));
    });
    useEffect(() => {
        if (updating)
            return;
        loadFilters().finally(() => {
            if (!initialized)
                setTimeout(() => setInitialized(true), 500);
        });
    }, [countryToReal, regionToReal, cityToReal, hotel /*, dates*/]);
    const validate = () => {
        setValidationCounter(v => v + 1);
        let flag = !countryToError && (rooms.length == 0 || rooms.filter(r => r.adults <= 0));
        if (!dates[0] || !moment(dates[0]).isValid() || !dates[1] || !moment(dates[1]).isValid()) {
            snackbar.enqueueSnackbar(_T.NEW_TOUR_SEARCH_SELECT_DATES_WARNING, { variant: 'warning', autoHideDuration: 5000 });
            flag = false;
        }
        if (moment(dates[1]).diff(moment(dates[0]), "days") >= 30) {
            snackbar.enqueueSnackbar(formatString(_T.NEW_TOUR_SEARCH_MAX_DATES_WARNING, [30]), { variant: 'warning', autoHideDuration: 5000 });
            flag = false;
        }
        if (props.newHotelSearchMaxCityCount && cityTo.length > props.newHotelSearchMaxCityCount) {
            snackbar.enqueueSnackbar(formatString(_T.NEW_TOUR_SEARCH_MAX_CITIES_WARNING, [props.newHotelSearchMaxCityCount]), { variant: 'warning', autoHideDuration: 5000 });
            flag = false;
        }
        if (props.newHotelSearchMaxCityCount && cityToOpt.length > props.newHotelSearchMaxCityCount && cityTo.length == 0) {
            snackbar.enqueueSnackbar(_T.NEW_TOUR_SEARCH_MIN_CITIES_WARNING, { variant: 'warning', autoHideDuration: 5000 });
            flag = false;
        }
        return flag;
    };
    useEffect(() => {
        if (!initialized)
            return;
        if (searchStr)
            search();
    }, [initialized]);
    const search = () => __awaiter(this, void 0, void 0, function* () {
        var _q;
        if (!validate())
            return;
        const version = ++searchVersion.current;
        let params = {
            regionTo: regionTo.filter(c => !!regionToOpt.find(x => x.id == c)),
            countryTo: countryToOpt.find(x => x.id == countryTo) ? countryTo : undefined,
            cityTo: cityTo.filter(c => !!cityToOpt.find(x => x.id == c)),
            starTo,
            hotelTo: hotel.filter(c => !!hotelOpt.find(x => x.id == c)),
            pansionTo: pansion,
            livingConditionTo: livingCondition,
            from: dates[0],
            to: dates[1],
            rooms: rooms.map(r => ({
                adults: r.adults,
                childs: r.childs,
                ages: r.childAccommodations.map(a => a.age)
            })),
            page: 0,
            includeStopSale: !noStopSales,
            childsWithPlaceOnly,
        };
        history.replace({ pathname: pathname, search: new URLSearchParams(toURLSearchParams(params)).toString(), state: historyState });
        setSearching(true);
        setSearchFailed(false);
        const r = yield apiBackdrop(() => api('post', '/NewHotel/Search', params), false, 900);
        if (capital && version !== searchVersion.current)
            return;
        setSearching(false);
        setSearchFailed(!r.response);
        if (r.response) {
            setSearchResult(r.response);
            setResultGroups(r.response.hotelGroups || []);
            setPageIndex(0);
            setLastSearchParams(params);
            if (!capital && !((_q = r.response.hotelGroups) === null || _q === void 0 ? void 0 : _q.length))
                snackbar.enqueueSnackbar(_T.NEW_TOUR_SEARCH_NO_PRICES, { variant: 'warning', autoHideDuration: 5000 });
            setTimeout(() => {
                if (resultsContainerRef.current)
                    resultsContainerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 200);
        }
        else {
            if (!capital)
                snackbar.enqueueSnackbar(fetchErrorMessage, { variant: 'error', autoHideDuration: 10000, onClick: onFetchErrorMessageClick });
        }
    });
    const loadMore = () => __awaiter(this, void 0, void 0, function* () {
        if (!lastSearchParams || loadingMore || (capital && (loadingMoreRef.current || searching)))
            return;
        const nextPage = pageIndex + 1;
        const version = searchVersion.current;
        loadingMoreRef.current = true;
        setLoadingMore(true);
        const request = () => api('post', '/NewHotel/Search', Object.assign(Object.assign({}, lastSearchParams), { page: nextPage }));
        try {
            const r = yield (capital ? request() : apiBackdrop(request, false, 900));
            if (capital && version !== searchVersion.current)
                return;
            if (r.response) {
                setPageIndex(nextPage);
                setResultGroups(prev => [...prev, ...(r.response.hotelGroups || [])]);
                setSearchResult(prev => { var _a; return prev ? Object.assign(Object.assign({}, prev), { hotelsFound: (_a = r.response.hotelsFound) !== null && _a !== void 0 ? _a : prev.hotelsFound }) : r.response; });
            }
            else {
                snackbar.enqueueSnackbar(fetchErrorMessage, { variant: 'error', autoHideDuration: 10000, onClick: onFetchErrorMessageClick });
            }
        }
        catch (_r) {
            if (!capital || version === searchVersion.current)
                snackbar.enqueueSnackbar(fetchErrorMessage, { variant: 'error', autoHideDuration: 10000, onClick: onFetchErrorMessageClick });
        }
        finally {
            loadingMoreRef.current = false;
            setLoadingMore(false);
        }
    });
    const capitalControls = {
        country: (React.createElement(Select, { variant: variant, label: _T.COMMON_COUNTRY, value: countryToReal, onChange: (e) => {
                let v = Number.parseInt(e.target.value);
                if (v != countryTo) {
                    setRegionTo([]);
                    setCityTo([]);
                }
                setCountryTo(v);
            }, inputProps: {
                name: 'countryTo',
                id: 'countryTo'
            }, fullWidth: true, error: countryToError }, countryToOpt.map((o, i) => (React.createElement("option", { key: i, value: o.id }, o.name))))),
        region: (React.createElement(Select, { variant: variant, label: _T.COMMON_REGION, value: regionToReal.length ? regionToReal[0] : "null", onChange: (e) => {
                let v = Number.parseInt(e.target.value || '0');
                if (v != regionToReal[0]) {
                    setRegionTo([]);
                    setCityTo([]);
                }
                setRegionTo(e.target.value == null ? [] : [v]);
            }, inputProps: {
                name: 'regionTo',
                id: 'regionTo'
            }, fullWidth: true },
            React.createElement("option", { value: "null" }, _T.COMMON_ALL),
            regionToOpt.map((o, i) => (React.createElement("option", { key: i, value: o.id }, o.name))))),
        city: (React.createElement(MultiSelectList, { multiline: true, heightPx: 300, title: (s) => !!props.newHotelSearchMaxCityCount
                ? (s.length == 0 ? `${_T.COMMON_CITY}/${_T.COMMON_RESORT} (${_T.COMMON_MAX} ${props.newHotelSearchMaxCityCount})` : `${_T.COMMON_CITY}/${_T.COMMON_RESORT} — ${s.length}/${props.newHotelSearchMaxCityCount}`)
                : (s.length == 0 || s.length == cityToOpt.length ? `${_T.COMMON_CITY}/${_T.COMMON_RESORT} — ${_T.COMMON_ALL}` : `${_T.COMMON_CITY}/${_T.COMMON_RESORT} — ${s.length}`), options: cityToOpt, valueSelector: "id", textSelector: "name", onChange: (selected) => setCityTo(selected), selected: cityTo, maxSelected: props.newHotelSearchMaxCityCount, maxSelectedAlertText: formatString(_T.NEW_TOUR_SEARCH_MAX_CITIES_WARNING, [props.newHotelSearchMaxCityCount]), error: cityToError })),
        pansion: (React.createElement(GroupedMultiSelectList, { title: (s) => (s.length == 0 || s.length == pansionOpt.length + livingCondition.length ? `${_T.COMMON_LIVING_CONDITION} — ${_T.COMMON_ALL}` : _T.COMMON_LIVING_CONDITION), optionGroups: livingConditionAndPansionOpt, valueSelector: "id", textSelector: "name", onChange: (selected) => {
                setPansion(selected.filter(s => s.group == 'meal').map(s => s.value));
                setLivingCondition(selected.filter(s => s.group == 'other').map(s => s.value));
            }, selected: livingConditionAndPansionSelected, variant: variant, multiline: true, heightPx: 300 })),
        dates: (React.createElement(DateRangePickerField, { presentationVariant: isCapitalUI ? 'capital' : undefined, displayFormat: props.newHotelSearchFilterDateFormat, label: _T.COMMON_CHECKIN_CHECKOUT_DATES, dates: dates, variant: variant, onChange: (d) => { var _a, _b; return setDates([(_a = d[0]) === null || _a === void 0 ? void 0 : _a.format('YYYY-MM-DD'), (_b = d[1]) === null || _b === void 0 ? void 0 : _b.format('YYYY-MM-DD')]); }, dateLimit: 30, dateLimitAlertText: formatString(_T.NEW_TOUR_SEARCH_MAX_DATES_WARNING, [30]), error: datesError })),
        tourists: (React.createElement(AccommodationSelector, { presentationVariant: isCapitalUI ? 'capital' : undefined, label: _T.COMMON_TOURIST_COUNT, minAdults: 1, minChilds: 0, maxAdults: props.newHotelSearchMaxAdultsPerRoom, maxChilds: props.newHotelSearchMaxChildsPerRoom, maxItems: props.newHotelSearchMaxRooms, multiply: true, maxChildAge: props.hotelSearchMaxChildAge, onChange: newValue => {
                setRooms(Array.isArray(newValue) ? newValue : [newValue]);
            }, value: rooms, required: true, itemGroupLabelFormat: `${_T.COMMON_HOTELROOM} {0}`, itemsCountInputLabel: _T.COMMON_HOTELROOMS_COUNT, useBootstrapInput: true, showChildsWithPlaceOnlySwitch: showChildsWithPlaceOnlySwitch, childsWithPlaceOnly: childsWithPlaceOnly, onChildsWithPlaceOnlyChange: setChildsWithPlaceOnly, childsWithPlaceOnlyLabel: _T.NEW_TOUR_SEARCH_CHILD_WITH_PLACE_ONLY_LABEL })),
        star: (React.createElement(MultiSelectList, { title: (s) => (s.length == 0 || s.length == starToOpt.length ? `${_T.COMMON_CATEGORY} — ${_T.COMMON_ALL}` : _T.COMMON_CATEGORY), options: starToOpt, valueSelector: "id", textSelector: "name", onChange: (selected) => setStarTo(selected), selected: starTo, variant: variant, multiline: true, heightPx: 300 })),
        hotel: (React.createElement(MultiSelectList, { multiline: true, searchable: true, heightPx: 300, title: (s) => s.length == 0 || s.length == hotelOptFiltered.length ? `${_T.COMMON_HOTEL} — ${_T.COMMON_ALL}` : `${_T.COMMON_HOTEL} — ${s.length}`, options: hotelOptFiltered, valueSelector: "id", textSelector: o => { var _a, _b; return `${o.name} ${(_b = (_a = o.category) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ''}`; }, onChange: (selected) => setHotel(selected), selected: hotel }))
    };
    return (React.createElement(SearchSurface, Object.assign({}, (props.hotelSearchResultVariant === 'capital' ? { className: 'capital-hotel-search' } : {})),
        React.createElement(Container, { id: 'new-tour-search-filters-main-container', disableGutters: true }, initialized ? capital ? React.createElement(CapitalHotelSearchForm, { controls: capitalControls, onSearch: search, switches: showNoStopSalesSwitch ? React.createElement(FormControlLabel, { label: _T.NEW_TOUR_SEARCH_NO_STOP_SALES_LABEL, control: React.createElement(Switch, { checked: noStopSales, onChange: event => setNoStopSales(event.target.checked) }) }) : null }) : React.createElement(Paper, null,
            React.createElement(Box, { display: "flex", padding: "32px", margin: "auto", justifyContent: "center" },
                React.createElement(Box, { flexGrow: 1, flexDirection: "column" },
                    React.createElement(Grid, { container: true, justifyContent: xs ? `space-evenly` : `space-between`, spacing: 2 },
                        React.createElement(Grid, { item: true, xs: 12, md: 6, container: true, className: classes.gridFilterFirstSecond, alignContent: "flex-start" },
                            React.createElement(Grid, { item: true, xs: 12, sm: 6 }, capitalControls.country),
                            React.createElement(Grid, { item: true, xs: 12, sm: 6 }, capitalControls.region),
                            React.createElement(Grid, { item: true, xs: 12, sm: 7 }, capitalControls.city),
                            React.createElement(Grid, { item: true, xs: 12, sm: 5 }, capitalControls.pansion)),
                        React.createElement(Grid, { item: true, xs: 12, md: 6, container: true, className: classes.gridFilterFirstSecond, alignContent: "flex-start" },
                            React.createElement(Grid, { item: true, xs: 12, sm: 6 }, capitalControls.dates),
                            React.createElement(Grid, { item: true, xs: 12, sm: 6 }, capitalControls.tourists),
                            React.createElement(Grid, { item: true, xs: 12, sm: 5 }, capitalControls.star),
                            React.createElement(Grid, { item: true, xs: 12, sm: 7 }, capitalControls.hotel)),
                        React.createElement(Grid, { item: true, xs: 12, container: true, justify: "space-between" },
                            showNoStopSalesSwitch ? React.createElement(FormControlLabel, { label: React.createElement(Typography, null, _T.NEW_TOUR_SEARCH_NO_STOP_SALES_LABEL), control: React.createElement(Switch, { checked: noStopSales, onChange: (e) => setNoStopSales(e.target.checked) }) }) : React.createElement("div", null),
                            React.createElement(Grid, { item: true, xs: 'auto' },
                                React.createElement(Button, { onClick: search, size: "large", color: "primary", variant: "contained", className: "tour-search-large-button" }, _T.COMMON_SEARCH))))))) : React.createElement("div", null)),
        searchResult && resultRows.length ? React.createElement("div", { style: { marginTop: '24px', marginBottom: md ? '48px' : '60px', marginLeft: 'auto', marginRight: 'auto' }, className: "tp-search-result-container", ref: resultsContainerRef },
            props.hotelSearchResultVariant === 'gagra' ? (React.createElement("div", { className: "ghs-result-list" }, gagraResultGroups.map(({ group, price }) => {
                const detailsUrl = appUrl('/Hotel/SearchDetails', { sd: searchResult.rqSerialized, hid: group.hotelId });
                return (React.createElement(GagraHotelSearchResultCard, { key: `${group.hotelId}-${price.bookingCode || price.roomNo}`, group: group, price: price, nights: searchResult.nights, detailsUrl: detailsUrl, bookingDisabled: addingToCart, onBook: (event, selectedPrice) => handlePriceClick(event, group, selectedPrice) }));
            }))) : React.createElement(Paper, { classes: { root: 'tp-search-result-paper' } },
                React.createElement(HorizontalScrollableBox, { topVisible: true, bottomVisible: false, ref: resultsScrollRef, onLoad: (s) => {
                        setTimeout(() => {
                            if (resultsScrollRef.current) {
                                let f = $(resultsScrollRef.current).stickyTable();
                                if (f && f[0])
                                    f[0].addEventListener('scroll', s);
                            }
                        }, 200);
                    } }, ({ scroll }) => (React.createElement("div", { ref: resultsScrollRef, onScroll: scroll },
                    React.createElement(Table, { className: "tp-search-table" },
                        React.createElement(TableHead, null,
                            React.createElement(TableRow, null,
                                columnVisibility.dates ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-header-cell tp-search-result-cell-date" }, _T.COMMON_DATES) : null,
                                columnVisibility.hotel ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-header-cell tp-search-result-cell-hotel" }, _T.COMMON_HOTEL) : null,
                                columnVisibility.hotelCategory ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-header-cell tp-search-result-cell-hotel-category" }, _T.COMMON_CATEGORY) : null,
                                columnVisibility.roomCategory || columnVisibility.roomType ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-header-cell tp-search-result-cell-tour" }, _T.COMMON_ROOM_CATEGORY) : null,
                                columnVisibility.accommodation ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-header-cell tp-search-result-cell-accomodation" }, _T.COMMON_ACCOMMODATION) : null,
                                columnVisibility.meal ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-header-cell tp-search-result-cell-meal" }, _T.COMMON_MEAL) : null,
                                columnVisibility.nights ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-header-cell tp-search-result-cell-nights" }, _T.COMMON_NIGHTS) : null,
                                columnVisibility.price ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-header-cell tp-search-result-cell-price" }, _T.COMMON_PRICE) : null)),
                        React.createElement(TableBody, null, resultRows.length ? resultRows.map(({ group, price }, rowIndex) => {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            const detailsUrl = appUrl('/Hotel/SearchDetails', { sd: searchResult.rqSerialized, hid: group.hotelId });
                            const begin = price.begin ? moment(price.begin) : null;
                            const end = price.end ? moment(price.end) : null;
                            const dateText = (begin === null || begin === void 0 ? void 0 : begin.isValid()) && (end === null || end === void 0 ? void 0 : end.isValid())
                                ? `${begin.format('DD.MM')}-${end.format('DD.MM')}`
                                : '';
                            const dateSubText = (begin === null || begin === void 0 ? void 0 : begin.isValid()) && (end === null || end === void 0 ? void 0 : end.isValid())
                                ? `${begin.format('dd')}-${end.format('dd')}`
                                : '';
                            const roomLabel = (_a = price.originalRoomName) !== null && _a !== void 0 ? _a : [columnVisibility.roomType ? (_b = price.roomType) === null || _b === void 0 ? void 0 : _b.name : undefined, columnVisibility.roomCategory ? (_c = price.roomCategory) === null || _c === void 0 ? void 0 : _c.name : undefined].filter(Boolean).join(' ');
                            const accmdLabel = getAccommodationDisplayName(price, (_d = price.accommodations) === null || _d === void 0 ? void 0 : _d.map(a => a.name).join('+'));
                            const priceCurrency = price.currencyISO || '';
                            const cityLabel = price.cityName || ((_e = cityToOpt.find(city => { var _a; return city.id === (price.cityId || ((_a = group.hotelDescription) === null || _a === void 0 ? void 0 : _a.cityId)); })) === null || _e === void 0 ? void 0 : _e.name);
                            const categoryLabel = group.hotelCategory || price.categoryName || (((_f = group.hotelDescription) === null || _f === void 0 ? void 0 : _f.starRating) ? `${group.hotelDescription.starRating}*` : '—');
                            const priceRubText = capital && priceCurrency.toUpperCase() !== 'RUB' && price.priceRub != null && Number.isFinite(price.priceRub)
                                ? `${formatMoney(price.priceRub, { localeAware: true, currency: 'RUB' })} RUB` : undefined;
                            const priceText = `${formatMoney(price.price, { localeAware: true, currency: priceCurrency })} ${priceCurrency}`.trim();
                            const handleClick = (evt) => handlePriceClick(evt, group, price);
                            return (React.createElement(TableRow, { key: `${group.hotelId}-${price.bookingCode || price.roomNo || rowIndex}` },
                                columnVisibility.dates ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-cell-date" },
                                    dateText,
                                    dateSubText ? React.createElement("div", { className: "subtext" }, dateSubText) : null) : null,
                                columnVisibility.hotel ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-cell-hotel" },
                                    React.createElement("a", { href: detailsUrl, className: "tour-url" }, group.hotelName),
                                    capital ? React.createElement("div", { className: "subtext" }, cityLabel || '—') : ((_g = group.hotelDescription) === null || _g === void 0 ? void 0 : _g.address) ? React.createElement("div", { className: "subtext" }, group.hotelDescription.address) : null,
                                    capital && !columnVisibility.roomType && !columnVisibility.roomCategory && price.externalProviderId && price.bookingCode ? React.createElement("div", null,
                                        React.createElement(HotelOfferConditions, { priceInternal: price.secureSerialized, checkIn: price.begin, className: "capital-hotel-room-conditions" })) : null) : null,
                                columnVisibility.hotelCategory ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-cell-hotel-category" }, capital ? categoryLabel : group.hotelCategory) : null,
                                columnVisibility.roomType || columnVisibility.roomCategory ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-cell-tour" }, capital && price.externalProviderId && price.bookingCode ? React.createElement(HotelOfferConditions, { priceInternal: price.secureSerialized, checkIn: price.begin, label: roomLabel, className: "capital-hotel-room-conditions" }) : roomLabel) : null,
                                columnVisibility.accommodation ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-cell-accomodation" }, accmdLabel) : null,
                                columnVisibility.meal ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-cell-meal" }, (_h = price.meal) === null || _h === void 0 ? void 0 : _h.name) : null,
                                columnVisibility.nights ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-cell-nights" }, searchResult.nights) : null,
                                columnVisibility.price ? React.createElement(TableCell, { className: "tp-search-result-cell tp-search-result-cell-price" },
                                    React.createElement("div", { className: "tp-price-with-cart" },
                                        React.createElement("div", { className: "tp-price-text" },
                                            React.createElement("a", { href: "#", onClick: handleClick, onTouchEnd: handleClick, className: "tour-url" },
                                                React.createElement("span", { className: "tp-price-main" }, priceText),
                                                priceRubText ? React.createElement("span", { className: "cost-in-rub" }, priceRubText) : null)),
                                        React.createElement("div", { className: "tp-price-cart-wrap" },
                                            React.createElement("a", { href: "#", onClick: handleClick, onTouchEnd: handleClick, "aria-label": _T.COMMON_CHOOSE || _T.COMMON_BUY },
                                                React.createElement(CartIcon, null)))),
                                    !capital && price.externalProviderId && price.bookingCode ? React.createElement(HotelOfferConditions, { priceInternal: price.secureSerialized, checkIn: price.begin, className: "hotel-offer-conditions__trigger tour-url" }) : null) : null));
                        }) : (React.createElement(TableRow, null,
                            React.createElement(TableCell, { colSpan: 8, className: "tp-search-result-cell" }, _T.NEW_TOUR_SEARCH_NO_PRICES))))))))),
            searchResult.hotelsFound && resultGroups.length < searchResult.hotelsFound ? (props.hotelSearchResultVariant === 'gagra'
                ? React.createElement(Button, { className: "ghs-load-more", variant: "contained", color: "primary", onClick: loadMore, disabled: loadingMore || searching }, _T.COMMON_LOAD_MORE)
                : React.createElement(Paper, { classes: { root: capital ? 'capital-search-pagination' : 'tp-search-result-paper' }, elevation: capital ? 0 : undefined },
                    React.createElement(Button, { startIcon: capital && loadingMore ? React.createElement("img", { className: "capital-search-load-more-spinner", src: appUrl('/Content/capital/assets/search-loading.svg'), alt: "" }) : undefined, className: capital ? "capital-search-load-more" : undefined, variant: capital ? "contained" : "text", color: capital ? "secondary" : "primary", centerRipple: true, fullWidth: !capital, "aria-busy": capital ? loadingMore : undefined, onClick: loadMore, disabled: loadingMore || searching }, _T.COMMON_LOAD_MORE))) : null) : null,
        capital && searchFailed ? React.createElement(Paper, { className: "capital-search-state", role: "alert" },
            React.createElement("p", null, _T.CAPITAL_SEARCH_LOAD_ERROR),
            React.createElement(Button, { color: "primary", onClick: search }, _T.COMMON_RETRY || 'Повторить')) : null,
        capital && searchResult && !resultRows.length && !searching && !searchFailed ? React.createElement(Paper, { className: "capital-search-state", role: "status" }, _T.NEW_TOUR_SEARCH_NO_PRICES) : null,
        React.createElement(HotelCompulsoryServicesDialog, { open: compulsoryDialogOpen, onClose: closeCompulsoryDialog, options: compulsoryOptions, selection: compulsorySelection, onSelect: setCompulsorySelection, onConfirm: handleCompulsoryConfirm })));
}
